"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    gridBox: {
      padding: spacing(2),
      borderRadius: 5,
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.1)',
      background: palette.common.white
    }
  };
});

var GridBox = function GridBox(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_material.Grid, (0, _extends2["default"])({
    className: classes.gridBox
  }, props));
};

var _default = /*#__PURE__*/(0, _react.memo)(GridBox);

exports["default"] = _default;